import type { CastctlFeatureSelection } from 'hooks/dialogs/cluster/components/CastctlOnboardingDialog';

type CastctlCommandFlags = {
  installWorkloadAutoscaler: boolean;
  installAutoscalerAgent: boolean;
  installReliabilityMetrics: boolean;
};

/**
 * Map the user-facing feature selection onto the boolean flags the castctl
 * connect-script API expects. Callers always provide an explicit
 * `featureFlags` so the resulting castctl command reflects the current
 * context (e.g. cost-monitoring-only defaults for reporting-trial orgs).
 */
export const getCastctlCommandFlags = (
  featureFlags: Partial<CastctlFeatureSelection>
): CastctlCommandFlags => ({
  installWorkloadAutoscaler: !!featureFlags.workloadAutoscaler,
  installAutoscalerAgent: !!featureFlags.autoscaler,
  installReliabilityMetrics: !!featureFlags.reliabilityMetrics,
});
